// находим нужные теги
export default function refsEl() {
  return {
    btnTestEl: document.querySelector('[data-login="sign-in"]'),
  };
}
